const extractIdFromGid = (gid) => gid?.match(/[^/]+$/i)[0];

exports.extractIdFromGid = extractIdFromGid;